import { Title } from "../../../../components";
import { useCustomTranslation } from "../../../../helpers/translateHelpers";
import HomeServiceObjectsUpcomingRevisionsTable from "./HomeServiceObjectsUpcomingRevisionsTable";

const HomeServiceObjectsUpcomingRevisionsContent = () => {
  const { tCommon } = useCustomTranslation();

  return (
    <div className="mb-2 sm:mt-4 sm:mb-4">
      <Title title={tCommon("home_upcoming_revisions")} />
      <p className="mb-4">{tCommon("home_upcoming_revisions_description")}</p>
      <HomeServiceObjectsUpcomingRevisionsTable />
    </div>
  );
};

export default HomeServiceObjectsUpcomingRevisionsContent;
